module.exports = __webpack_public_path__ + "img/Icon_white.929fd5b1.svg";